class SearchRedirects {
  constructor() {
    // Early exit if redirects are disabled
    if (!this.isEnabled()) return;
    
    this.redirects = this.parseRedirects();
    this.exactMatch = window.searchRedirectConfig.exactMatch;
    
    // Only initialize if we have redirects
    if (this.redirects.size > 0) {
      this.initializeSearchIntercept();
    }
  }

  isEnabled() {
    return window.searchRedirectConfig && 
           window.searchRedirectConfig.enabled && 
           window.searchRedirectConfig.rules;
  }

  parseRedirects() {
    const redirectMap = new Map();
    const rules = window.searchRedirectConfig.rules;
    
    if (!rules) return redirectMap;
    
    // Parse the redirect rules with synonym support
    rules.split('\n').forEach((line, index) => {
      // Trim the line
      line = line.trim();
      
      // Skip empty lines and comments (lines starting with #)
      if (!line || line.startsWith('#')) return;
      
      const parts = line.split('|');
      if (parts.length === 2) {
        const termsSection = parts[0].trim();
        const url = parts[1].trim();
        
        if (termsSection && url) {
          // Split by comma to support multiple terms/synonyms
          const terms = termsSection.split(',').map(term => term.trim().toLowerCase());
          
          // Add each term as a separate entry pointing to the same URL
          terms.forEach(term => {
            if (term) {
              redirectMap.set(term, url);
            }
          });
        }
      } else if (parts.length !== 2 && line.length > 0) {
        // Log malformed rules for debugging (but don't break)
        console.warn(`Search Redirects: Skipping malformed rule at line ${index + 1}: "${line}"`);
      }
    });
    
    console.log(`Search Redirects: Loaded ${redirectMap.size} redirect rules`);
    return redirectMap;
  }

  checkForRedirect(searchTerm) {
    if (!searchTerm) return null;
    
    const normalizedTerm = searchTerm.toLowerCase().trim();
    
    // Check for exact match first
    if (this.redirects.has(normalizedTerm)) {
      console.log(`Search Redirects: Exact match found for "${searchTerm}"`);
      return this.redirects.get(normalizedTerm);
    }
    
    // If not exact match mode, check if any redirect term is contained
    if (!this.exactMatch) {
      for (const [term, url] of this.redirects) {
        // Check if search contains the term
        if (normalizedTerm.includes(term)) {
          console.log(`Search Redirects: Partial match found for "${searchTerm}" (matched: "${term}")`);
          return url;
        }
      }
    }
    
    return null;
  }

  initializeSearchIntercept() {
    // Find all search forms (header, mobile, and search page)
    const searchForms = document.querySelectorAll('form[action*="/search"]');
    
    searchForms.forEach(form => {
      // Remove any existing listeners to avoid duplicates
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      newForm.addEventListener('submit', (e) => this.handleSearchSubmit(e));
    });
    
    // Also intercept predictive search form submissions
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action*="/search"]')) {
        this.handleSearchSubmit(e);
      }
    }, true);
  }

  handleSearchSubmit(e) {
    const form = e.target;
    const searchInput = form.querySelector('input[type="search"]');
    
    if (!searchInput) return;
    
    const searchTerm = searchInput.value.trim();
    const redirectUrl = this.checkForRedirect(searchTerm);
    
    if (redirectUrl) {
      e.preventDefault();
      e.stopPropagation();
      
      // Add loading state to the search button
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        const originalText = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.style.opacity = '0.6';
      }
      
      // Handle relative and absolute URLs
      if (redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://')) {
        // External URL
        window.location.href = redirectUrl;
      } else if (redirectUrl.startsWith('/')) {
        // Relative URL
        window.location.href = redirectUrl;
      } else {
        // Assume it's a page handle
        window.location.href = '/' + redirectUrl;
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SearchRedirects();
  });
} else {
  new SearchRedirects();
}